// columns.tsx

import { formatNumber, parseDate } from "@/lib/utils";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";

export type MacroKeyword = {
  id: string;
  time_serie_id: number | null;
  macro_type: string;
  name: string | null;
  created_at: string;
  updated_at: string;
};

export const macro_keyword_columns: ColumnDef<MacroKeyword>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    accessorKey: "time_serie_id",
    header: "Time Series ID",
    cell: ({ row }) => {
      const value = row.getValue("time_serie_id");
      return value != null ? formatNumber(Number(value)) : "";
    },
  },
  {
    accessorKey: "macro_type",
    header: "Macro Type",
    cell: ({ row }) => {
      const value = row.getValue("macro_type");
      return value ? String(value) : "";
    },
  },
  {
    accessorKey: "name",
    header: "Name",
    cell: ({ row }) => {
      const value = row.getValue("name");
      return value ? String(value) : "";
    },
  },
  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => parseDate(row.getValue("created_at")),
  },
  {
    accessorKey: "updated_at",
    header: "Updated At",
    cell: ({ row }) => parseDate(row.getValue("updated_at")),
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => (
      <div className="flex justify-end">
        <Link
          href={`${window.location.pathname}/${row.getValue("id")}`}
          className="text-xs"
          underline="hover"
        >
          {i18n.t("actions.edit")}
        </Link>
      </div>
    ),
  },
];
